<template>
    <div class="label_labour">
        <div class="pt_cs_good_pr"
            @click="showPopupLabour"
            @mouseenter="onHoverEnter"
            @mouseleave="onHoverLeave"
        >
            <span class="title">
                Gold Weight Pricing
            </span>
            <div class="bg_transparent"></div>
            <div class="pt_custom_icon_good" >
                <div class="pt_icon"></div>
            </div>
            <div class="main_pt_good_pr" v-if="isPopupVisible">
                <div class="gold_price_title home_title">{{ goldWeightData.title }}</div>
                <div class="gold_price_desc home_sub-titles">
                    <p></p>
                    <p v-html="convertUrlsToLocale(goldWeightData.description, baseUrl, locale)"></p>
                    <p></p>
                </div>
                <div class="table-wraper">
                    <table>
                        <thead>
                            <tr>
                                <th>Gold</th>
                                <th>Current Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in goldWeightData.data" :key="item.slug">
                                <td>
                                <a :href="`${baseUrl}api/material/${item.slug}`">{{ item.name }}</a>
                                <p>(per gm)</p>
                                </td>
                                <td>
                                    <span class="woocommerce-Price-amount amount">
                                        <bdi><span class="woocommerce-Price-currencySymbol" v-html="displayCustomPrice(item.price)"></span></bdi>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                Updated as of {{ goldWeightData.date }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="pt_ac_mobile">
                    <button class="pt_done_mb" @click.stop="closePopupLabour">DONE</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_labourcost.scss";
</style>

<script setup lang="ts">
    import { displayCustomPrice, displayPrice } from "~/utils/displayPrice"
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;

    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { convertUrlsToLocale } from '~/utils/getLangUrl';
    const props = defineProps({
        data: {
            type: Object,
            required: true
        },
    });
    const labourData = computed(() => props.data);
    const goldWeightData = computed(() => labourData.value.goldWeightData);
    const isPopupVisible = ref(false);

    const showPopupLabour = () => {
        if (window.innerWidth <= 768) {
            isPopupVisible.value = true;
            document.body.style.overflowY = 'hidden';
            document.body.classList.add('has_open_modal');
        }
    };

    const closePopupLabour = () => {
        if (window.innerWidth <= 768) {
            isPopupVisible.value = false;
            document.body.style.overflowY = 'auto';
            document.body.classList.remove('has_open_modal');
        }
    };

    const onHoverEnter = () => {
        if (window.innerWidth > 768) {
            isPopupVisible.value = true;
        }
    };

    const onHoverLeave = () => {
        if (window.innerWidth > 768) {
            isPopupVisible.value = false;
        }
    };

</script>
